export default "icons-rotate-left"